import { render, staticRenderFns } from "./FormSectionDialog.vue?vue&type=template&id=5d171b8c&scoped=true"
import script from "./FormSectionDialog.vue?vue&type=script&lang=js"
export * from "./FormSectionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d171b8c",
  null
  
)

export default component.exports